<template> 
    <div> 
        <img :src="configTni.consent_standard_register_success_image_url" alt="" /> 
    </div> 
</template>
<script>  

import ConfigManager from '@/config/ConfigManager';
//service
import ConsentApi from '../../ConsentRegister/service/ConsentApi';

export default {
    name: "StarndardRegisterSuccessPage", 
    components: {  
    },
    data: function() {
        return {   
            configTni: {},
        }
    },
    created: function() { 
        this.getBlobConfig();
        this.redirectToChat();
    },
    methods: { 
        getBlobConfig: function() {
            ConsentApi.apiGetTniConfig().subscribe({
                next: (data) => {
                    this.configTni = data;
                    
                },
                error: (err) => {
                    this.errorApi(err);
                },
            });
        }, 
        redirectToChat: function() {
            setTimeout(() => {
                const lineId = ConfigManager.getLineId()
                let urlSchemeOpenLine = "https://line.me/R/ti/p/" + lineId

                window.location = urlSchemeOpenLine
            }, 3000);
        }
    },
}
</script>

